import React, { useEffect, useState } from 'react';
import { Row, Col } from 'reactstrap';
import iconCongratulations from '../../../assets/img/icon-congratulation.svg';
import iconAllDone from '../../../assets/img/ico-all-done.svg';

const Result = ({ user, validations, hanndleNextQuestion, items, response_range, section, prevState }) => {
  const [countdown, setCountdown] = useState(5);
  const btn_text = 'Next';
  const range_group_1 = response_range.get("1");
  const range_group_2 = response_range.get("2");
  const range_group_3 = response_range.get("3");

  let error_group_1 = null;
  let error_group_2 = null;
  let error_group_3 = null;

  if (!validations.group_1.valid && validations.group_1.error === 'min') {
    error_group_1 = <p className='text-danger mx-3 mx-md-3'><small>The minimum number for talents for the "Always" bucket is {range_group_1.min}. In the next screen, please add the strongest talent(s) from your "Sometimes" bucket.</small></p>;
  }

  if (!validations.group_1.valid && validations.group_1.error === 'max') {
    error_group_1 = <p className='text-danger mx-3 mx-md-3'><small>In the next screen, please select additional talents that aren't quite as strong and mark them as "Sometimes" to narrow the list down to your top {range_group_1.max}.</small></p>;
  }

  if (!validations.group_2.valid && validations.group_2.error === 'min') {
    error_group_2 = <p className='text-danger mx-3 mx-md-3'><small>The minimum number for talents for the "Sometimes" bucket is {range_group_2.min}. In the next screen, please add the talent(s).</small></p>;
  }

  if (!validations.group_2.valid && validations.group_2.error === 'max') {
    error_group_2 = <p className='text-danger mx-3 mx-md-3'><small>The maximum number for talents for the "Sometimes" bucket is {range_group_2.max}. In the next screen, please remove the talent (s) to your "Sometimes" bucket.</small></p>;
  }

  if (!validations.group_3.valid && validations.group_3.error === 'min') {
    error_group_3 = <p className='text-danger mx-3 mx-md-3'><small>The minimum number for talents for the "Never" bucket is {range_group_3.min}. In the next screen, please add the talent(s).</small></p>;
  }

  if (!validations.group_3.valid && validations.group_3.error === 'max') {
    error_group_3 = <p className='text-danger mx-3 mx-md-3'><small>The maximum number for talents for the "Never" bucket is {range_group_3.max}. In the next screen, please remove the talent (s) to your "Never" bucket.</small></p>;
  }

  const show_rearrenge = (section === 'result_1' || !validations.valid);
  const enabledCountdown = show_rearrenge && !user?.talents?.length;

  useEffect(() => {
    if (enabledCountdown) {
      const timer = setInterval(() => {
        setCountdown((prevCount) => {
          if (prevCount === 1) {
            clearInterval(timer);
            hanndleNextQuestion('rearrenge');
          }
          return prevCount - 1;
        });
      }, 1000);

      return () => clearInterval(timer);
    }
  }, [hanndleNextQuestion, enabledCountdown]);

  return (
    <>
      <div>
        <div className="text-center content-result">
          <div className='mb-3 pt-md-4'>
            {validations.valid && !prevState && <h2 className="mb-4 libre-caslon-text-regular h4-md h5">All Done!!</h2>}
            <h2 className='mb-4 libre-caslon-text-regular h4-md h5'>Hey! {user.first_name}, Here are your Thinking Talents</h2>
          </div>

          {validations.valid && <div className="mx-auto mb-4"><img src={iconAllDone} height="80" alt="All Done" /></div>}
          {!validations.valid && <div className="mx-auto mb-4"><img src={iconCongratulations} height="80" alt="Congratulations" /></div>}

          {!prevState &&
            <div className='mb-4'>
              <p className='font-weight-semibold h4-md h5'>Congratulations!</p>
              <p className='h5-md h6 font-weight-normal'>You have identified the Thinking Talents that give you energy</p>
            </div>
          }

          <div className="d-flex justify-content-center">
            <div className="px-2 px-md-4 text-center">
              <div className={"rounded ttcard bg-always border " + (validations.group_1.valid ? 'border-always' : 'border-danger')}>
                <span className='text-capitalize h4 font-weight-normal d-block d-md-inline'>Always</span>
                <span className='d-block d-md-inline h4 ml-2 font-weight-bold libre-caslon-text-regular'>{items.group_1.size}</span>
              </div>
              {!validations.group_1.valid && <h6 className="text-danger"><small>{validations.group_1.message}</small></h6>}
            </div>
            <div className="px-2 px-md-4 text-center">
              <div className={"rounded ttcard bg-white border " + (validations.group_2.valid ? 'border-sometimes' : 'border-danger')}>
                <span className='text-capitalize h4 font-weight-normal d-block d-md-inline'>Sometimes</span>
                <span className='d-block d-md-inline h4 ml-2 font-weight-bold libre-caslon-text-regular'>{items.group_2.size}</span>
              </div>
              {!validations.group_2.valid && <h6 className="text-danger"><small>{validations.group_2.message}</small></h6>}
            </div>
            <div className="px-2 px-md-4 text-center">
              <div className={"rounded ttcard bg-never border " + (validations.group_3.valid ? 'border-never' : 'border-danger border')}>
                <span className='text-capitalize h4 font-weight-normal d-block d-md-inline'>Never</span>
                <span className='d-block d-md-inline h4 ml-2 font-weight-bold libre-caslon-text-regular'>{items.group_3.size}</span>
              </div>
              {!validations.group_3.valid && <h6 className="text-danger"><small>{validations.group_3.message}</small></h6>}
            </div>
          </div>
          {validations.valid &&
            <>
              <p className="mt-4 mb-2 small">On the next screen, you can review the talents you chose and rearrange them if you like.</p>
            </>
          }

          {error_group_1}
          {error_group_2}
          {error_group_3}

          <div className="text-center mt-auto">
            {show_rearrenge &&
              <Row>
                <Col md={{ size: 4, offset: 4 }}>
                  {enabledCountdown
                    ? <p className='text-muted'>
                      <small>
                        Redirecting to review & rearrange in {countdown}s
                      </small>
                    </p>
                    : <button onClick={() => hanndleNextQuestion('rearrenge')} className="btn btn-sm btn-green-light text-uppercase">{btn_text}</button>
                  }
                </Col>
              </Row>
            }
            {!show_rearrenge && <>
              <p className="h4 text-center text-reset">Tap Next to map your talents</p>
              <Row>
                <Col md={{ size: 4, offset: 4 }}>
                  <button onClick={() => hanndleNextQuestion('summary')} className="btn btn-sm btn-primary text-uppercase">{btn_text}</button>
                </Col>
              </Row>
            </>
            }
          </div>
        </div>
      </div>
    </>
  );
};

export default Result;